import {PersonSelectorProps, personsSelector, useGetAllPersonsQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BasePersonMultiSelect, BasePersonMultiSelectProps} from "./BasePersonMultiSelect";

export type PersonMultiSelectProps = Omit<BasePersonMultiSelectProps, "entities" | "loading"> & {
  selector?: PersonSelectorProps
}

export const PersonMultiSelect = (props: PersonMultiSelectProps) => {
  const {selector, ...rest} = props;

  const selectPersons = useMemo(() => {
    return personsSelector();
  }, []);

  const {persons, isLoading} = useGetAllPersonsQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      persons: selectPersons(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BasePersonMultiSelect entities={persons} loading={isLoading} {...rest} />;
};
